console.log('room');

const types = document.querySelectorAll('.popType');
const typeClose = document.querySelectorAll('.popType .closeBtn button');
const pickItems = document.querySelectorAll('.pickItem');

pickItems.forEach((pick, index) => {
    pick.addEventListener('click', function () {
        types[index].classList.add('show');
    })
})

typeClose.forEach((close) => {
    close.addEventListener('click', function () {
        types.forEach((type) => {
            type.classList.remove('show');

        })
    })
})